import { Stack } from '@mui/material';
import Label from 'src/components/Label';
import { isHardClosedPeriod } from './closedPeriod';

type Props = {
  //  `location.state` from the alert view.
  dateRange: any;
  /** Finance has closed the books on the financial period this one falls in (BOPS-170). */
  isLocked: boolean;
};

/**
 * The period's status pills, under the date-range heading (BOPS-170).
 *
 * "Closed & signed" is the same green Label the Closeout Alerts row carries, repeated here because
 * the story's second pill has to sit *alongside* it and this page had no pill of its own. Both are
 * scoped to a hard-closed period, so no other period page gains a pill it did not have before.
 *
 * "Invoiced & locked" is grey rather than red or amber on purpose: finance closing the books is
 * the normal end of a month, not a fault or a warning the facility has to act on.
 */
const ClosedPeriodStatusPills = (props: Props) => {
  const { dateRange, isLocked } = props;

  if (!isHardClosedPeriod(dateRange)) return null;

  return (
    <Stack
      direction="row"
      alignItems="center"
      flexWrap="wrap"
      gap="8px"
    >
      <Label
        backgroundColor="#15B79E1F"
        color="#107569"
        text="CLOSED & SIGNED"
      />
      {isLocked && (
        <Label
          backgroundColor="#F3F4F6"
          color="#4B5563"
          text="INVOICED & LOCKED"
        />
      )}
    </Stack>
  );
};

export default ClosedPeriodStatusPills;
